// extracted by mini-css-extract-plugin
export default {"milestonesTableContainer":"Milestones_milestonesTableContainer__Rf0dI"};